import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import { EditorDeclarativeBlock } from '@/webapi/use-experience-api';

interface VisibilityToggleProps {
  change: EditorDeclarativeBlock;
  isSynced: boolean;
  onClick?: () => void;
}

export function VisibilityToggle({
  change,
  isSynced,
  onClick,
}: VisibilityToggleProps) {
  const onClickWrapper = (ev: React.MouseEvent) => {
    ev.stopPropagation();
    if (onClick) onClick();
  };

  if (!isSynced) {
    return <div />;
  }

  return (
    <VisibilityWrapper
      className={`${change?.isDisabled ? `disabled` : `active`}`}
      onClick={onClickWrapper}
    >
      {change?.isDisabled && (
        <StaticImage
          src="../invisible.svg"
          alt="eye"
          placeholder="none"
          loading="eager"
        />
      )}
      {!change?.isDisabled && (
        <StaticImage
          src="../visible.svg"
          alt="crossed eye"
          placeholder="none"
          loading="eager"
        />
      )}
    </VisibilityWrapper>
  );
}

const VisibilityWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .gatsby-image-wrapper {
    width: 1.7rem;
  }

  &.active {
    opacity: 0.4;
    cursor: zoom-out;
  }

  &.disabled {
    opacity: 0.4;
    cursor: zoom-in;
  }
`;
